import { atom } from 'jotai';

import { itemGroupUpdateAtom } from '../_graphql/mutationItemGroupUpdate';
import { itemGroupDetailQueryAtom } from '../_graphql/queryItemGroupDetail';

import { settingsRouteParamAtom } from './settingsModule.state';

// 🟣🟣🟣 PARAMS
export const $itemGroupId = settingsRouteParamAtom(
  ['/inventory/item-groups/:id'],
  'id',
);

// 🟢🟢🟢 REMOTE DATA
export const $remoteItemGroupDetail = itemGroupDetailQueryAtom((get) => {
  const itemGroupId = get($itemGroupId);
  return {
    variables: {
      ids: itemGroupId ? [itemGroupId] : [],
    },
    skip: !itemGroupId,
  };
});

// 🟢🟢🟢 COMPUTED DATA
export const $isItemGroupLoading = atom((get) => {
  const data = get($remoteItemGroupDetail);
  return data?.isLoading ?? false;
});

export const $itemGroupError = atom((get) => {
  const data = get($remoteItemGroupDetail);
  return data?.error ?? null;
});

// 🟠🟠🟠 ACTION -> UPDATE item group
export const $updateItemGroup = itemGroupUpdateAtom({
  onSuccess: (get) => {
    get($remoteItemGroupDetail).refetch?.();
  },
});
